import React, { useState, useEffect, useRef } from 'react';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Toast } from "primereact/toast";

import './VisualizarAsistencias.scss';
import { useExcelExport } from '../../../utilidades/customHooks/useExcelExport';
import { formatearFecha } from '../../../utilidades/formateos';
import { getAsistencias } from './integracion';

import Swal from "sweetalert2";
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";

const VisualizarAsistencias = () => {
    const { exportarAExcel } = useExcelExport();
    const dt = useRef(null);
    const op = useRef(null);
    const toast = useRef(null);

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const [startDate, setStartDate] = useState(firstDayOfMonth);
    const [endDate, setEndDate] = useState(lastDayOfMonth);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notaSeleccionada, setNotaSeleccionada] = useState('');

    // Llamada a la API cuando cambian filtros
    useEffect(() => {
        if (!startDate || !endDate) return;

        setLoading(true);
        const params = {
            fecha_inicio: formatearFecha(startDate),
            fecha_fin: formatearFecha(endDate),
        };

        Swal.fire({
            title: 'Cargando...',
            text: 'Obteniendo datos...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        getAsistencias(params).then((data) => {
            setData(data);
            Swal.close();
            setLoading(false);

        }).catch(err => {
            console.log(err);
            Swal.close();
            setLoading(false);
        });
    }, [startDate, endDate]);

    const exportData = () => {
        const dataToExport = data.map(row => ({
            Folio: row.FOLIO,
            Usuario: row.USUARIO,
            Puesto: row.PUESTO,
            Cliente: row.CLIENTE,
            Motivo: row.MOTIVO,
            Tipo: row.TIPO,
            Fecha: row['FECHA/HORA'],
            Ubicacion: row.UBICACION
        }));

        exportarAExcel(dataToExport, [
            { field: 'Folio', header: 'Folio' },
            { field: 'Usuario', header: 'Usuario' },
            { field: 'Puesto', header: 'Puesto' },
            { field: 'Cliente', header: 'Cliente' },
            { field: 'Motivo', header: 'Motivo' },
            { field: 'Tipo', header: 'Tipo' },
            { field: 'Fecha', header: 'Fecha / Hora' },
            { field: 'Ubicacion', header: 'Ubicación' },
        ], "REPORTE DE ASISTENCIAS");
    };



    const ubicacionTemplate = (rowData) => {
        const handleOpenUbicacion = () => {
            if (rowData.UBICACION) {
                window.open(rowData.UBICACION, '_blank', 'noopener,noreferrer');
            } else {
                alert("No hay ubicación disponible.");
            }
        };

        return (
            <Button
                type="button"
                icon="pi pi-map-marker"
                label="Ubicación"
                text
                tooltip="Ver ubicacion"
                className="p-button-primary"
                onClick={handleOpenUbicacion}
            />
        );
    };

    const notaTemplate = (rowData) => {
        return (
            <Button type="button" icon="pi pi-eye" severity="help" text label="Ver" tooltip="Ver Nota"
                    onClick={(e) => {
                        setNotaSeleccionada(rowData.NOTAS || 'Sin nota');
                        op.current.toggle(e);
                    }}/>
        )
    }


    return (
        <div className="data-module-container">
            <Toast ref={toast} />
            <OverlayPanel ref={op}>
                <div style={{ padding: '0.5rem', maxWidth: '300px' }}>
                    {notaSeleccionada}
                </div>
            </OverlayPanel>
            <div className="filters-grid">
                <div className="filter-item">
                    <label htmlFor="startDate">Fecha Inicio</label>
                    <Calendar
                        id="startDate"
                        value={startDate}
                        onChange={(e) => setStartDate(e.value)}
                        maxDate={endDate || undefined}
                        minDate={new Date(today.getFullYear(), today.getMonth() - 2, 1)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        readOnlyInput={true}
                    />
                </div>
                <div className="filter-item">
                    <label htmlFor="endDate">Fecha Fin</label>
                    <Calendar
                        id="endDate"
                        value={endDate}
                        onChange={(e) => setEndDate(e.value)}
                        minDate={startDate || new Date(today.getFullYear(), today.getMonth() - 2, 1)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        readOnlyInput={true}
                    />
                </div>
                <div className="filter-item">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search"> </InputIcon>
                        <InputText
                            id="globalSearch"
                            type="search"
                            value={globalFilterValue}
                            onChange={(e) => setGlobalFilterValue(e.target.value)}
                            placeholder="Buscar en la tabla..."
                        />
                    </IconField>
                </div>
                <div className="filter-item button-export-wrapper">
                    <Button
                        type="button"
                        icon="pi pi-file-excel"
                        label="Exportar Excel"
                        onClick={exportData}
                        className="p-button-success"
                    />
                </div>
            </div>

            <div className="datatable-container">
                {loading && <p>Cargando datos...</p>}
                {!loading && data.length === 0 && (
                    <p className="no-data-message">
                        No hay datos disponibles para los filtros seleccionados.
                    </p>
                )}
                <DataTable
                    ref={dt}
                    value={data}
                    scrollable
                    scrollHeight="flex"
                    virtualScroll
                    rows={25}
                    className="p-datatable-sm"
                    globalFilter={globalFilterValue}
                    globalFilterFields={['FOLIO', 'USUARIO', 'FECHA/HORA', 'UBICACION']}
                >
                    <Column field="FOLIO" header="Folio" />
                    <Column field="USUARIO" header="Usuario" />
                    <Column field="PUESTO" header="Puesto" />
                    <Column field="CLIENTE" header="Cliente" />
                    <Column field="MOTIVO" header="Motivo" />
                    <Column field="TIPO" header="Tipo"/>
                    <Column field="FECHA/HORA" header="Fecha/Hora" />
                    <Column field="NOTAS" header="Notas" body={notaTemplate} />
                    <Column field="UBICACION" header="Ubicación" body={ubicacionTemplate} />
                </DataTable>
            </div>
        </div>
    );
};

export default VisualizarAsistencias;
